<template>
    <div>
        <div>
            <div class="col-11 text-right menu-locale">
                <base-button
                    size="sm"
                    type="primary"
                    v-if="this.$i18n.locale == 'en'"
                    @click="en()"
                    >EN</base-button
                >
                <base-button
                    size="sm"
                    type="neutral"
                    v-if="this.$i18n.locale == 'th'"
                    @click="en()"
                    >EN</base-button
                >
                <base-button
                    size="sm"
                    type="primary"
                    v-if="this.$i18n.locale == 'th'"
                    @click="th()"
                    >TH</base-button
                >
                <base-button
                    size="sm"
                    type="neutral"
                    v-if="this.$i18n.locale == 'en'"
                    @click="th()"
                    >TH</base-button
                >
            </div>
        </div>
        <!-- Header -->
        <div class="header  py-7 py-lg-6 pt-lg-1">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-md-8 px-5">
                            <!-- <img src="img/dtac.png" alt="" style="width:30%;height:auto;" /> -->
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="separator separator-bottom separator-skew zindex-100"
            ></div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <img src="img/logo.png" class="bo-login__logo" alt="MadameFin" />
                            <div class="text-center text-muted mb-4">
                                <br />
                                {{ appName }}
                                <br />
                                <small>{{ $t("auth.signin") }}</small>
                            </div>
                            <validation-observer
                                v-slot="{ handleSubmit }"
                                ref="formValidator"
                            >
                                <form
                                    role="form"
                                    @submit.prevent="handleSubmit(onSubmit)"
                                >
                                    <base-input
                                        alternative
                                        class="mb-3"
                                        name="Email"
                                        error="error"
                                        prepend-icon="ni ni-email-83"
                                        :placeholder="$t('auth.username')"
                                        v-model="model.email"
                                        autocomplete="off"
                                    >
                                    </base-input>

                                    <base-input
                                        alternative
                                        class="mb-3"
                                        name="Password"
                                        prepend-icon="ni ni-lock-circle-open"
                                        type="password"
                                        :placeholder="$t('auth.password')"
                                        v-model="model.password"
                                        autocomplete="off"
                                    >
                                    </base-input>

                                    <div class="text-center">
                                        <base-button
                                            type="primary"
                                            native-type="submit"
                                            class="my-4 btn-info"
                                            >{{
                                                $t("auth.signin")
                                            }}</base-button
                                        >
                                        <base-button
                                            type="default"
                                            native-type="button"
                                            class="my-4 btn-info"
                                            >{{
                                                $t("auth.forgetpassword")
                                            }}</base-button
                                        >
                                    </div>

                                </form>
                            </validation-observer>

                            <!--
                                Login with LINE (spec 2026-10-03 §5).

                                OUTSIDE the <form> and the validation-observer
                                on purpose: it is not a submit, it does not read
                                model.email/password, and it must not be able to
                                trip the form's required-field validation. It
                                also deliberately does NOT call $recaptcha —
                                OAuth at LINE is the human check for this door
                                (spec §1 "Login ด้วย LINE" step 1), and asking
                                for a reCAPTCHA token on a button that only
                                redirects would gate the redirect on Google
                                being reachable.
                            -->
                            <div class="line-divider d-flex align-items-center my-3">
                                <span class="px-3 text-muted text-sm">{{
                                    $t("auth.or")
                                }}</span>
                            </div>

                            <button
                                type="button"
                                class="btn btn-block btn-line"
                                :disabled="lineBusy"
                                @click="onLineSignin"
                            >
                                <!--
                                    Inline SVG, not `fab fa-line`: the
                                    FontAwesome stylesheet is a CDN <link>
                                    (public/index.html:30) and the login page is
                                    exactly where a blocked CDN leaves a button
                                    with no icon and no explanation.
                                -->
                                <svg
                                    class="btn-line__icon"
                                    viewBox="0 0 24 24"
                                    width="20"
                                    height="20"
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M12 2C6.486 2 2 5.63 2 10.09c0 3.998 3.56 7.345 8.37 7.977.325.07.768.215.88.494.1.251.066.645.032.9l-.142.86c-.043.254-.202 1 .88.545 1.083-.455 5.843-3.44 7.976-5.89C21.33 13.26 22 11.74 22 10.09 22 5.63 17.514 2 12 2Z"
                                    />
                                    <!--
                                        The LINE wordmark inside the balloon,
                                        drawn as four subpaths left to right:
                                        L, I, N, E. Hand-built rather than
                                        copied, and verified by rendering — the
                                        first draft of this path came out
                                        reading "NIE L" and nothing in the test
                                        suite could have told us. If you edit
                                        it, LOOK at it.
                                    -->
                                    <path
                                        :fill="lineBrandColor"
                                        d="M6.3 7.8H7.08V11.42H8.9V12.2H6.3ZM9.7 7.8H10.45V12.2H9.7ZM11.25 7.8H12.03L13.47 10.6V7.8H14.25V12.2H13.47L12.03 9.4V12.2H11.25ZM15.05 7.8H17.65V8.58H15.83V9.61H17.65V10.39H15.83V11.42H17.65V12.2H15.05Z"
                                    />
                                </svg>
                                <span class="btn-line__label">{{
                                    $t("auth.line_signin")
                                }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueI18n from "vue-i18n";
import { mapActions, mapGetters, matGetters } from "vuex";
import swal from "sweetalert2";
import { setAuthCookie } from "@/util/auth-cookie";
import {
    LINE_BRAND_COLOR,
    LINE_PURPOSE_LOGIN,
    lineErrorKeyFromError,
    rememberLinePurpose
} from "@/utils/boLine";
const qs = require("querystring");

console.log(process.env.VUE_APP_RECAPTCHA);

export default {
    data() {
        return {
            appName: process.env.VUE_APP_TITLE,
            appVersion: process.env.VUE_APP_VERSION,
            recaptchaKey: process.env.VUE_APP_RECAPTCHA,
            model: {
                email: process.env.VUE_APP_USER,
                password: process.env.VUE_APP_PASSWORD,
                // email: "admin@asr.dev",
                // password: "P@ssw0rd",
                rememberMe: false
            },
            user: "agent",
            token: "",
            // Guards against a double tap sending two authorize-url requests
            // (each one mints a state in Redis and eats the per-IP cap of
            // 20/10min — spec §1 "Security invariants").
            lineBusy: false,
            lineBrandColor: LINE_BRAND_COLOR
        };
    },
    computed: {
        ...mapGetters({
            getUser: "Auth/getUser",
      getLocale: "Auth/getLocale"
        })
    },
    async mounted() {
		this.$i18n.locale = this.getLocale;
        await this.$recaptchaLoaded();
        this.$recaptchaInstance.showBadge();
    },
    methods: {
        ...mapActions({
            setUser: "Auth/setUser",
      setLocale: "Auth/setLocale",
            SignIn: "Auth/SignIn",
            lineAuthorizeUrl: "Auth/lineAuthorizeUrl",
        }),
        en() {
      this.$i18n.locale = "en";
	  this.setLocale("en");
    },
    th() {
      this.$i18n.locale = "th";
	  this.setLocale("th");
    },
        async onSubmit() {
            this.token = await this.$recaptcha("login");
            this.SignIn({
                username: this.model.email,
                password: this.model.password,
                token: this.token
            })
                .then(res => {
					console.log(res)
                        // Scope the cookie to .madamefin.com so subdomains
                        // (bo-stg ↔ api-stg) share it — required for
                        // <img src=".../files/..."> to carry auth.
                        setAuthCookie(this.$cookie, res.data.Token);
                        // can_view_cost rides beside User in the login body
                        // (bo-api #594 §4.5) — it is deliberately NOT a JWT
                        // claim, so it is read here and nowhere else.
                        // can_create_coupon_event rides along the same way and
                        // for the same reason (coupon-event spec §2).
                        this.setUser({
                            ...res.data.User,
                            CanViewCost: res.data.can_view_cost === true,
                            CanCreateCouponEvent: res.data.can_create_coupon_event === true,
                            // spec 2026-10-16 §6: Seller Center permissions (UI hint)
                            SellerAccess: res.data.seller_access,
                        });
						this.$recaptchaInstance.hideBadge();
                        this.$router.push("/");
				})
                .catch(err => {
					console.log(err)
                    // Backend returns {msg: "errors.auth.login_fail"} on 401.
                    // Fall back to the generic key if the shape is missing
                    // (e.g. network error / CORS) so the user never sees an
                    // empty-titled swal.
                    const key = (err.response && err.response.data && err.response.data.msg) || "errors.auth.login_fail";
                    swal.fire({
                        title: this.$t(key),
                        text: ``,
                        size: `sm`,
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
                });
        },

        // onLineSignin — step 1-3 of spec §1 "Login ด้วย LINE".
        //
        // It asks the API for an authorize URL and hands the browser over. The
        // `state` and `nonce` inside that URL are minted by the BE with
        // crypto/rand and verified only there (spec §1 "Security invariants"),
        // so this method must not generate, inspect or store either — the
        // mdf-www LINE flow does roll its own state with Math.random() and then
        // skips the comparison when one side is blank (gap M9); that mistake
        // must not be copied here.
        //
        // No $recaptcha call: see the comment on the button in the template.
        async onLineSignin() {
            if (this.lineBusy) return;
            this.lineBusy = true;
            try {
                const res = await this.lineAuthorizeUrl(LINE_PURPOSE_LOGIN);
                const url = res && res.data && res.data.url;
                if (!url) {
                    // A 200 with no url means the API answered a shape we do not
                    // understand; redirecting to "undefined" would leave the
                    // user on a browser error page with no way back.
                    throw new Error("missing authorize url");
                }
                // Written before the redirect so the callback page knows which
                // of the two flows it is completing (spec §5).
                rememberLinePurpose(LINE_PURPOSE_LOGIN);
                window.location.href = url;
            } catch (err) {
                this.lineBusy = false;
                swal.fire({
                    title: this.$t(lineErrorKeyFromError(err)),
                    text: ``,
                    size: `sm`,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            }
        }
    }
};
</script>

<style scoped>
/* Square brand logo shown as a circle on the login card (share previews and
   the favicon keep the square file). */
.bo-login__logo {
  display: block;
  width: 120px;
  height: 120px;
  margin: 8px auto 0;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}
.menu-locale {
    padding-top: 0.25in;
}

.divider:after,
.divider:before {
    content: "";
    flex: 1;
    height: 1px;
    background: #eee;
}

/* "หรือ" rule either side of the label (spec 2026-10-03 §5). */
.line-divider:after,
.line-divider:before {
    content: "";
    flex: 1;
    height: 1px;
    /* #dee2e6, not the #eee above: on the card's bg-secondary a 1px #eee line
       is below 1.3:1 against its background and simply is not visible. */
    background: #dee2e6;
}

/* LINE's brand green is fixed by their guidelines — it is NOT a theme colour,
   so it is written here instead of going through Argon's btn-* variants.
   #06C755 with #fff text is 2.6:1, which is why the label is 600 weight at
   0.875rem+ (large text) and the icon carries the shape of the meaning. */
.btn-line {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #06c755;
    border-color: #06c755;
    color: #fff;
    font-weight: 600;
}

.btn-line:hover,
.btn-line:focus {
    background-color: #05b14c;
    border-color: #05b14c;
    color: #fff;
}

/* A visible focus ring: the button is reachable by keyboard and Argon's
   default outline:none would leave tab users with no idea where they are. */
.btn-line:focus {
    box-shadow: 0 0 0 3px rgba(6, 199, 85, 0.45);
    outline: none;
}

.btn-line:disabled,
.btn-line[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
}

.btn-line__icon {
    flex: 0 0 auto;
    margin-right: 0.5rem;
}

.btn-line__label {
    line-height: 1.2;
}
</style>
